const HEADER_MIN_WIDTH = 200;

export const columns = [
  {
    field: 'docID',
    headerName: 'Doc ID',
    apiName: 'DocID',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 0,
    sortable: true,
  },
  {
    field: 'action',
    headerName: 'Action',
    apiName: 'ActionType',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 1,
    sortable: true,
  },
  {
    field: 'actionOn',
    headerName: 'Action On',
    apiName: 'ActionOn',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 2,
    sortable: true,
  },
  {
    field: 'userName',
    headerName: 'User',
    apiName: 'UserName',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 3,
    sortable: true,
  },
  {
    field: 'dateTime',
    headerName: 'Date/Time (UTC)',
    apiName: 'DocumentDate',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    isVisible: true,
    index: 4,
    sortable: true,
  },
];
